import { render, staticRenderFns } from "./simpleChild.vue?vue&type=template&id=7dec203e&"
import script from "./simpleChild.vue?vue&type=script&lang=js&"
export * from "./simpleChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports